// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2j91D","ranges":"BmiRanges_ranges__3Tu7t"};